import { useIsBenefitEngineAdmin } from "hooks/useBenefitEngineAdmin";
import useDocumentTitle from "hooks/useDocumentTitle";
import { TabPanel, TabView } from "primereact/tabview";

import { LineTypesTab } from "./LineTypesTab";
import { PayerOverridesTab } from "./PayerOverridesTab";

/**
 * CLE-2792 — Eligibility: the payer-agnostic settings behind every eligibility check.
 *
 * A TABBED page. The tabs are not decoration: line types and payer overrides both belong to
 * eligibility as a whole rather than to one account or one payer, and giving the first one a page of
 * its own would have meant moving it when the second arrived — which it now has.
 *
 * Line types come first because a payer override is read on top of whatever the line selection
 * found, so the tab order is the order the engine runs them.
 *
 * ⚠️ VISIBLE TO ONE PERSON while the engine is mid-cutover — see `useBenefitEngineAdmin`. The route
 * is ALSO super-admin protected; this hides a screen, it does not protect an endpoint.
 */
export function EligibilityPage() {
  useDocumentTitle("Eligibility");
  const isEngineAdmin = useIsBenefitEngineAdmin();

  if (!isEngineAdmin) return null;

  return (
    <div className="p-4" data-testid="eligibilityPage">
      <h2 className="m-0 mb-3">Eligibility</h2>
      <TabView data-testid="eligibilityPage.tabs">
        <TabPanel header="Line types">
          <LineTypesTab />
        </TabPanel>
        <TabPanel header="Payer overrides">
          <PayerOverridesTab />
        </TabPanel>
      </TabView>
    </div>
  );
}
